'use client';

import WorkspaceCTA from '../../v2/WorkspaceCTA';

function ShieldIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 2.8 20 6v5.2c0 5.1-3.3 8.4-8 10-4.7-1.6-8-4.9-8-10V6l8-3.2Z" />
      <path d="m8.5 12 2.2 2.2 4.8-5" />
    </svg>
  );
}

export default function BrandNoticeLayout2({ copy: c }) {
  return (
    <>
      <link rel="stylesheet" href="/assets/css/blog-layout-2.css" />
      <link rel="stylesheet" href="/assets/css/content-layout-2.css" />
      <link rel="stylesheet" href="/assets/css/brand-notice-layout-2.css" />

      <main className="brand-notice-v2">
        <header className="brand-notice-v2__hero">
          <div className="brand-notice-v2__wrap">
            <div className="brand-notice-v2__hero-copy">
              <p className="brand-notice-v2__eyebrow"><span><ShieldIcon /></span> AdCast Digital Signage</p>
              <h1>{c[0]}</h1>
              <p className="brand-notice-v2__updated">{c[1]}</p>
            </div>

            <div className="brand-notice-v2__domain-card">
              <span className="brand-notice-v2__status"><i aria-hidden="true" /> {c[2]}</span>
              <a href="https://www.adcast.app">adcast.app <span aria-hidden="true">↗</span></a>
              <div className="brand-notice-v2__divider" />
              <p>{c[3]}</p>
            </div>
          </div>
        </header>

        <section className="brand-notice-v2__content">
          <div className="brand-notice-v2__wrap brand-notice-v2__grid">
            <article className="brand-notice-v2__feature">
              <span className="brand-notice-v2__number">01</span>
              <div>
                <h2>{c[4]}</h2>
                <p>{c[5]}</p>
                <p>{c[6]}</p>
                <div className="brand-notice-v2__not-affiliated">
                  <span className="brand-notice-v2__crossed-domain">
                    <span>adcast.store</span>
                    <svg viewBox="0 0 110 24" preserveAspectRatio="none" aria-hidden="true">
                      <path d="M3 20.5 107 3.5" />
                    </svg>
                  </span>
                  <i aria-label="is not equal to">≠</i>
                  <strong>adcast.app</strong>
                </div>
              </div>
            </article>

            <article className="brand-notice-v2__section">
              <span className="brand-notice-v2__number">02</span>
              <div><h2>{c[7]}</h2><p>{c[8]}</p></div>
            </article>

            <article className="brand-notice-v2__section">
              <span className="brand-notice-v2__number">03</span>
              <div><h2>{c[9]}</h2><p>{c[10]}</p></div>
            </article>

            <WorkspaceCTA />
          </div>
        </section>
      </main>
    </>
  );
}
